/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, Flag, LockOutline} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSUSUARIOS} from "../../Constantes";

const Formulario_Acceso = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Numero de Cc'} dato={'cc'} {...props}
                                   requerido={'El Numero de Cc es requerido'} type={'number'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={LockOutline} nombre={'Codigo Acceso'} dato={'codigo'} {...props}
                                  requerido={'El Codigo Acceso es requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Acceso